import dayjs, { Dayjs } from "dayjs";
import { useCallback } from "react";

export const useDisabledPastDates = () => {
  return useCallback((selected: Dayjs): boolean => {
    return selected && dayjs().isAfter(selected);
  }, []);
};
